<template>
    <div class="toast-container position-fixed top-0 end-0 p-3" style="width:20%; z-index: 999;">
        <div id="liveToast" class="toast" role="alert" aria-live="assertive" aria-atomic="true" style="display: block;">
            <div class="toast-body" style="background-color:aliceblue">
                <div class="text-center">
                    <strong>
                        {{ textState }}
                    </strong>
                </div>
                <div>
                    <strong>Nome: </strong>{{ props.userName }}
                </div>
                <div>
                    <strong> CPF: </strong>{{ props.userCPF }}
                </div>
                <div>
                    <strong> Computador:</strong> {{ props.computerName }}
                </div>
                <div>
                    <strong>CFC:</strong> {{ props.CFCName }}
                </div>
            </div>
        </div>
    </div>
</template>


<script setup lang="ts">
import { ref, Ref } from "vue";

const props = defineProps({
    userName: { type: String, required: true },
    userCPF: { type: String, required: true },
    computerName: { type: String, required: true },
    CFCName: { type: String, required: true },
    state: { type: String, required: false, default: '' },
    test_over: { type: Boolean, required: true },
    test_middle: { type: Boolean, required: true },
});


const textState: Ref<string> = ref('Abertura da prova');


if (props.test_over) {
    textState.value = 'Finalização da Prova'
}

if (props.test_middle) {
    textState.value = 'Verificação de Biometria'
}


</script>
